import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { COLORS, SEAT_STATUSES } from '../constants'

const ColorLabelsPPP = ({ showStatusesLabel, colors = {} }) => {
  return (
    <div className='colorLabelsContainer'>
      <div className='colorLabelLine colorLabelLine-ppp'>
        {showStatusesLabel[SEAT_STATUSES.BLOCKED] && (
          <div className='colorLabel colorLabel-ppp'>
            <FontAwesomeIcon
              className='colorLabelColorTimesIcon'
              icon={faTimes}
            />
            <span className='colorLabelText'>Blocked</span>
          </div>
        )}
        <div className='colorLabel colorLabel-ppp'>
          <div
            style={{ backgroundColor: '#9bb4c0' }}
            className='colorLabelColor'
          />
          <div
            style={{ backgroundColor: '#fff' }}
            className='colorLabelColor'
          />
          <span className='colorLabelText'>Available</span>
        </div>
        {showStatusesLabel[SEAT_STATUSES.RESERVED] && (
          <div className='colorLabel colorLabel-ppp'>
            <div
              style={{
                backgroundColor: `${colors.RESERVED || COLORS.RESERVED}`
              }}
              className='colorLabelColor'
            />
            <span className='colorLabelText'>Reserved</span>
          </div>
        )}
        <div className='colorLabel colorLabel-ppp'>
          <div
            style={{ backgroundColor: `${colors.BOOKED || COLORS.BOOKED}` }}
            className='colorLabelColor'
          />
          <span className='colorLabelText'>Sold</span>
        </div>
      </div>
    </div>
  )
}

export { ColorLabelsPPP }
